/** @format */

import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const dateConstants = {
    DATE_EDIT: 'date_edit',
};

export class DateActions extends defaultActions {}
